import { createAction, props } from '@ngrx/store';

export interface DirectorySettingValue {
    name: string;
    value: string;
}

export interface DirectorySetting {
    id: string;
    displayName?: string;
    templateId?: string;
    values: DirectorySettingValue[];
}

export const loadDirectorySettings = createAction(
    '[Graph/directory settings] Load Directory Settings',
    props<{ _tenant: string }>(),
);

export const loadDirectorySettingsSuccess = createAction(
    '[Graph/directory settings] Load Directory Settings Success',
    props<{ _tenant: string; settings: DirectorySetting[] }>(),
);

export const loadDirectorySettingsFailure = createAction(
    '[Graph/directory settings] Load Directory Settings Failure',
    props<{ _tenant: string; error: any }>(),
);

export const createDirectorySetting = createAction(
    '[Graph/directory settings] Create Directory Setting',
    props<{ _tenant: string; templateId: string; values: DirectorySettingValue[] }>(),
);

export const updateDirectorySetting = createAction(
    '[Graph/directory settings] Update Directory Setting',
    props<{ _tenant: string; id: string; values: DirectorySettingValue[] }>(),
);

export const updateDirectorySettingSuccess = createAction(
    '[Graph/directory settings] Update Directory Setting Success',
    props<{ _tenant: string; settings: DirectorySetting[] }>(),
);

export const updateDirectorySettingFailure = createAction(
    '[Graph/directory settings] Update Directory Setting Failure',
    props<{ _tenant: string; error: any }>(),
);
